import {
defineCustomElement,
MediaSliderChaptersElement
} from "vidstack/elements";

defineCustomElement(MediaSliderChaptersElement);